import mapboxgl from '!mapbox-gl';

export default class SearchMap {
  constructor(mapContainer) {
    mapboxgl.accessToken = 'pk.eyJ1IjoidGhlc2hyaW5rc3BhY2UiLCJhIjoiY2pveXVlcXljMmpmNDN4bWxxdXU2ZTF5bSJ9.1fSUfOi71bu24kUsjnd6Pg';

    this.resultsContainer = document.querySelector('.search-results .results');
    this.therapistCards = document.querySelectorAll('.therapist-card');
    this.customMapMarker = document.querySelector('.map-marker svg');
    this.showMapButton = document.getElementById('show-map');
    this.hideMapButton = document.getElementById('hide-map');
    this.mapContainer = mapContainer;

    this.generateMarkersDataRepresentation();
    this.initializeMapbox();
    this.initializeTherapistCardsHover();
    this.initializeShowMapButton();
    this.initializeHideMapButton();
  }

  generateMarkersDataRepresentation() {
    this.markers = {};

    document.querySelectorAll('[data-therapists-map-info]').forEach((mel) => {
      const mapInfo = JSON.parse(mel.dataset.therapistsMapInfo).filter((minfo) => {
        return minfo.coords.filter((dd) => Boolean(dd)).length === 2;
      });
      mapInfo.map((minfo) => {
        this.markers[minfo.id] = [];

        const mapMarkerElement = this.customMapMarker.cloneNode(true);
        mapMarkerElement.classList.add('map-pin');

        const popup = this.buildPopup(minfo);
        const marker = this.buildMarker(
          minfo.coords.map((el) => Number(el)),
          mapMarkerElement,
          popup
        );

        this.markers[minfo.id].push({
          marker,
          mapMarkerElement
        });
      });
    });
  }

  initializeMapbox() {
    let center = this.getInitialCenter();

    this.map = new mapboxgl.Map({
      container: this.mapContainer.id,
      interactive: true,
      zoom: 13,
      style: 'mapbox://styles/mapbox/streets-v9'
    });

    if (center && center.length) {
      this.map.setCenter(center);
    } else {
      this.map.setCenter([-73.9720605, 40.7750971]);
    }

    if (Object.keys(this.markers).length > 0) {
      this.map.fitBounds(this.getMapFitBounds(), {
        maxZoom: 13,
        padding: {
          top: 50,
          bottom: 50,
          left: 50,
          right: 50
        }
      });
    }

    this.map.addControl(
      new mapboxgl.NavigationControl({
        showCompass: false
      })
    );

    this.drawMarkers();
  }

  initializeTherapistCardsHover() {
    if (Object.keys(this.markers).length > 0) {
      for (let therapistCard of this.therapistCards) {
        therapistCard.addEventListener('mouseenter', (event) => {
          let therapistCard = event.target.closest('.therapist-card');
          let therapistID = therapistCard.dataset.therapistId;
          let mapMarkers = this.markers[therapistID];

          if (!mapMarkers) { return; }

          for (let mapMarker of mapMarkers) {
            mapMarker.mapMarkerElement.classList.add('active');
          }
        });

        therapistCard.addEventListener('mouseleave', (event) => {
          let therapistCard = event.target.closest('.therapist-card');
          let therapistID = therapistCard.dataset.therapistId;
          let mapMarkers = this.markers[therapistID];

          if (!mapMarkers) { return; }

          for (let mapMarker of mapMarkers) {
            mapMarker.mapMarkerElement.classList.remove('active');
          }
        });
      }
    }
  }

  getInitialCenter() {
    let resultsDiv = document.querySelector('.search-results .results');
    let longitude = resultsDiv.dataset.longitude;
    let latitude = resultsDiv.dataset.latitude;

    if (!longitude || !latitude) {
      return null;
    }

    return [resultsDiv.dataset.longitude, resultsDiv.dataset.latitude];
  }

  getMapFitBounds() {
    let boundingBox = new mapboxgl.LngLatBounds();

    Object.keys(this.markers).map((key) => {
      for (let officeCoords of this.markers[key]) {
        boundingBox.extend(officeCoords.marker.getLngLat());
      }
    });

    return boundingBox;
  }

  drawMarkers() {
    Object.keys(this.markers).forEach((key) => {
      for (let officeCoords of this.markers[key]) {
        officeCoords.marker.addTo(this.map);
      }
    });
  }

  buildPopup(minfo) {
    let markerHeight = 30,
      markerRadius = 20,
      linearOffset = 25;
    let popupOffsets = {
      top: [0, 0],
      'top-left': [0, 0],
      'top-right': [0, 0],
      bottom: [0, -markerHeight],
      'bottom-left': [linearOffset, (markerHeight - markerRadius + linearOffset) * -1],
      'bottom-right': [-linearOffset, (markerHeight - markerRadius + linearOffset) * -1],
      left: [markerRadius, (markerHeight - markerRadius) * -1],
      right: [-markerRadius, (markerHeight - markerRadius) * -1]
    };

    let popup = new mapboxgl.Popup({
      offset: popupOffsets,
      closeButton: false
    });
    let popupContent = document.createElement('div');

    popupContent.classList.add('therapist-style', 'popup-therapist-info');
    popupContent.innerHTML = `
      <div class="therapist-name">
        <a class="text-reset" href="${minfo.url}"><strong>${minfo.name}</strong></a>
      </div>

      <div class="therapist-license">
        ${minfo.license}
      </div>

      <div class="therapist-specialties">
        ${minfo.specialties}
      </div>
    `;
    popup.setDOMContent(popupContent);

    return popup;
  }

  buildMarker(officeCoords, mapMarkerElement, popup) {
    let marker = new mapboxgl.Marker({ element: mapMarkerElement });

    marker.setLngLat(officeCoords);
    marker.setPopup(popup);

    return marker;
  }

  initializeShowMapButton() {
    if (!this.showMapButton) {
      return null;
    }

    this.showMapButton.addEventListener('click', () => {
      this.resultsContainer.classList.add('d-none');
      this.mapContainer.classList.add('mobile-fix');
      this.showMapButton.classList.add('d-none');
      this.hideMapButton.classList.add('d-block');

      this.map.resize();
      this.map.fitBounds(this.getMapFitBounds(), {
        maxZoom: 13,
        padding: {
          top: 50,
          bottom: 50,
          left: 50,
          right: 50
        }
      });
    });
  }

  initializeHideMapButton() {
    if (!this.hideMapButton) {
      return null;
    }

    this.hideMapButton.addEventListener('click', () => {
      this.resultsContainer.classList.remove('d-none');
      this.mapContainer.classList.remove('mobile-fix');
      this.showMapButton.classList.remove('d-none');
      this.hideMapButton.classList.remove('d-block');
    });
  }
}
